function ExternalLink({ to, children })
{
    return <a className="fw-bold text-decoration-none text-reset" href={to} target="_blank" rel="noopener noreferrer">{children}</a>;
}

export default ExternalLink;